import Text from 'components/shared/Text'
import { Color, TextVariant } from 'styles/types'
import { BungalowFeatureWrapper } from './styles'

interface BungalowFeatureProps {
    icon: string
    iconAlt: string
    quantity?: number
    fontVariant?: TextVariant
    textColor?: Color
    highlightedText: string
    additionalInformation?: string
    hasBorderBottom?: boolean
}

const BungalowFeature = ({
    icon,
    iconAlt,
    quantity,
    fontVariant = 'bodyExtraSmall',
    textColor = 'grayscale_900',
    highlightedText,
    additionalInformation,
    hasBorderBottom = false,
}: BungalowFeatureProps) => (
    <BungalowFeatureWrapper
        isFullWidth={true}
        direction="row"
        gap={8}
        align="center"
        hasBorderBottom={hasBorderBottom}
    >
        <img src={icon} alt={iconAlt} />

        {!!quantity && (
            <>
                <Text variant={fontVariant} color={textColor}>
                    {quantity}
                </Text>
                <Text as="span" variant={fontVariant} color="grayscale_700">
                    {' x '}
                </Text>
            </>
        )}

        <Text variant={fontVariant} color={textColor}>
            {highlightedText}
        </Text>
        {!!additionalInformation && (
            <Text variant="bodyExtraSmall" color="grayscale_700">
                {additionalInformation}
            </Text>
        )}
    </BungalowFeatureWrapper>
)

export default BungalowFeature
